import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { FallGardenClubCategory, FallGardenClubResource } from '../types/fallGardenClub';

export function useFallGardenClub() {
  const [resources, setResources] = useState<FallGardenClubResource[]>([]);
  const [categories, setCategories] = useState<FallGardenClubCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const [resourcesResult, categoriesResult] = await Promise.all([
          supabase
            .from('fall_garden_club_resources')
            .select(`
              *,
              category:fall_garden_club_categories (
                id,
                name,
                slug,
                description
              )
            `)
            .eq('status', 'active')
            .order('sort_order', { ascending: true }),
          supabase
            .from('fall_garden_club_categories')
            .select('id, name, slug, description')
            .order('name'),
        ]);

        if (resourcesResult.error) throw resourcesResult.error;
        if (categoriesResult.error) throw categoriesResult.error;

        setResources(resourcesResult.data || []);
        setCategories(categoriesResult.data || []);
      } catch (err) {
        console.error('Error fetching Fall Garden Club data:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return { resources, categories, loading, error };
}
